module.exports = __webpack_public_path__ + "static/assets/042a4888fd5737d866bf70a7811f14b2.gif";